// UpdateModal.js
import React, { useState } from 'react';
import { FaDownload, FaTimes, FaExclamationTriangle } from 'react-icons/fa';
import Button from './buttons/Button';
import '../Home/home.css';

const UpdateModal = ({ updateInfo, onClose, onUpdate }) => {
  const [showInfo, setShowInfo] = useState(false);
  if (!updateInfo || !updateInfo.latest) {
    return null;
  }

  const { latest } = updateInfo;
  const isMandatory = latest.isMandatory;

  const handleUpdate = async () => {
    if (onUpdate) {
      onUpdate();
    }
    const ua = (typeof navigator !== 'undefined' ? navigator.userAgent : '') || '';
    const plat = (typeof navigator !== 'undefined' ? navigator.platform : '') || '';
    const isMac = /Mac|Macintosh|MacIntel/i.test(ua) || /Mac/i.test(plat);
    const defaultUrl = isMac
      ? 'https://voxia-md.ch/public/downloads/voxia.dmg'
      : 'https://voxia-md.ch/public/downloads/voxia.exe';
      
    const downloadUrl = latest?.url || defaultUrl;
    const filename = latest?.filename || (isMac ? 'voxia.dmg' : 'voxia.exe');
    let downloaded = false;
    try {
      if (window.electronAPI && window.electronAPI.downloadFile) {
        const result = await window.electronAPI.downloadFile(downloadUrl, filename);
        downloaded = !!result?.success;
      }
    } catch (_) {}
    if (!downloaded) {
      window.open(
        downloadUrl,
        '_blank',
        'noopener,noreferrer'
      );
    }
    // After 2 seconds, reset app (Electron) and close modal
    try {
      await new Promise(resolve => setTimeout(resolve, 2000));
      if (window.electronAPI && window.electronAPI.resetAppData) {
        await window.electronAPI.resetAppData();
      }
    } catch (_) {}
    if (!isMandatory && onClose) {
      onClose();
    }
  };

  const handleShowInfo = () => {
    setShowInfo(true);
  };

  const handleConfirm = () => {
    setShowInfo(false);
    // Start download/update flow and close the modal immediately if allowed
    // Do not await to allow immediate UI close
    handleUpdate();
    if (!isMandatory && onClose) {
      onClose();
    }
  };

  const handleClose = () => {
    if (!isMandatory && onClose) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={!isMandatory ? handleClose : undefined}>
      <div className="modal update-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            {isMandatory ? (
              <>
                <FaExclamationTriangle className="warning-icon" />
                Mise à jour obligatoire
              </>
            ) : (
              'Nouvelle version disponible'
            )}
          </h3>
          {!isMandatory && (
            <button className="modal-close" onClick={handleClose}>
              <FaTimes />
            </button>
          )}
        </div>

        <div className="modal-body">
          <div className="version-info">
            <p className="version-number">
              Version {latest.version}
              {latest.build && ` (Build ${latest.build})`}
            </p>
          </div>

          {latest.releaseNotes && (
            <div className="release-notes">
              <h4>Notes de version :</h4>
              <p>{latest.releaseNotes}</p>
            </div>
          )}

          {isMandatory && (
            <div className="mandatory-notice">
              <p>Cette mise à jour est requise pour continuer à utiliser l'application.</p>
            </div>
          )}

          {showInfo && (
            <div className="update-info">
              <p>
                La nouvelle version sera téléchargée dans votre dossier Téléchargements, puis l'app sera fermée.
                Il faudra ensuite utiliser cette nouvelle version de l'app qui est la plus à jour.
              </p>
            </div>
          )}
        </div>

        <div className="modal-actions">
          {showInfo ? (
            <Button
              type="fixed"
              variant="primary"
              onClick={handleConfirm}
            >
              J'ai compris
            </Button>
          ) : (
            <>
              <Button
                type="fixed"
                variant="primary"
                onClick={handleShowInfo}
                icon={FaDownload}
              >
                Mettre à jour maintenant
              </Button>
              {!isMandatory && (
                <Button
                  type="fixed"
                  variant="secondary"
                  onClick={handleClose}
                >
                  Plus tard
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateModal;